import React from "react";
import { Image, View } from "react-native";
import { CheckBox, Text } from "react-native-elements";
import { theme } from "../../../config/style-configs/theme";
import { ThemedInput } from "../../../components/ThemedInput";
import { ThemedButton } from "../../../components/ThemedButton";
import { observer } from "mobx-react";
import Icon from "react-native-vector-icons/MaterialIcons";
import { UIText } from "../../../config/lang-config";
import { embeddedService } from "../../../cdm/services/embedded-service";

@observer
class LoginScreen extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.rendered = false;
  }

  componentDidMount() {
    return this.controller.componentDidMount();
  }

  renderMfaScreen() {
    return (
      <View style={this.props.styles.style}>
        <View style={this.props.styles.header}>
          <Image
            source={theme.loginLogo}
            style={this.props.styles.headerLogo}
          />
        </View>

        <View style={{ ...this.props.styles.fields, maxWidth: 350 }}>
          <Text
            style={{
              ...this.props.styles.inputTitle,
              textAlign: "center",
              width: "100%"
            }}
          >
            {UIText.mfaPrompt}
          </Text>
        </View>
        <View style={{ ...this.props.styles.fields, maxWidth: 350 }}>
          <ThemedInput
            ref={input => {
              this.mfaCodeInput = input;
            }}
            placeholder={UIText.mfaVerificationCode}
            leftIcon={<Icon name="lock" size={24} color="black" />}
            leftIconContainerStyle={{ marginTop: 0 }}
            returnKeyType="go"
            value={this.controller.mfaCode}
            editable={
              !this.controller.mfaVerifying &&
              this.controller.mfaAttemptsRemaining > 0
            }
            keyboardType="numeric"
            maxLength={6}
            onChange={this.controller.updateMfaCode}
            onEndEditing={this.controller.updateMfaCode}
            onSubmitEditing={this.controller.verifyMfaCode}
          />
        </View>

        <CheckBox
          containerStyle={{
            backgroundColor: "transparent",
            borderWidth: 0,
            paddingHorizontal: 20,
            marginBottom: 10
          }}
          title={UIText.mfaTrustDevice}
          checkedIcon={<Icon name="check-box" size={24} color="black" />}
          uncheckedIcon={
            <Icon name="check-box-outline-blank" size={24} color="black" />
          }
          checked={this.controller.mfaTrust}
          checkedColor={theme.color}
          disabled={this.controller.mfaAttemptsRemaining === 0}
          onPress={this.controller.toggleMfaTrust}
        />

        {!!this.controller.mfaError && (
          <View style={{ paddingHorizontal: 20, marginBottom: 20 }}>
            <Text style={{ color: "red", textAlign: "center" }}>
              {this.controller.mfaError}
            </Text>
          </View>
        )}

        {this.controller.mfaAttemptsRemaining === 0 ? (
          <ThemedButton
            title="Start Again"
            onPress={this.controller.handleStartAgain}
          />
        ) : (
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <ThemedButton
              style={{ flex: 1, marginRight: 5 }}
              disabled={this.controller.mfaVerifying}
              title={UIText.mfaBack || "Back"}
              onPress={this.controller.handleStartAgain}
            />
            <ThemedButton
              style={{ flex: 1, marginLeft: 5 }}
              disabled={
                this.controller.mfaVerifying || !this.controller.mfaCode
              }
              title={UIText.mfaContinue}
              loading={this.controller.mfaVerifying}
              onPress={this.controller.verifyMfaCode}
            />
          </View>
        )}
      </View>
    );
  }

  render() {
    if (this.controller.mfaRequired) {
      return this.renderMfaScreen();
    }

    setTimeout(() => {
      if (this.username && !!this.username.props.value && !this.rendered) {
        this.rendered = true;
        this.username.focus();
      }
    });
    return (
      <View style={this.props.styles.style}>
        <View style={this.props.styles.header}>
          <Image
            source={theme.loginLogo}
            style={this.props.styles.headerLogo}
          />
        </View>

        <View style={this.props.styles.fields}>
          <ThemedInput
            ref={input => {
              this.username = input;
            }}
            placeholder={UIText.loginFieldUsername}
            leftIcon={<Icon name="person" size={24} color="black" />}
            returnKeyType="next"
            value={this.controller.fieldData.username}
            editable={!this.controller.signingIn}
            onChange={e => {
              this.controller.updateFields("username", e);
            }}
            onEndEditing={e => {
              this.controller.updateFields("username", e);
            }}
            onBlur={e => {
              this.username.props.onEndEditing(e);
            }}
            onSubmitEditing={() => {
              this.password.focus();
            }}
          />
        </View>
        <View style={this.props.styles.fields}>
          <ThemedInput
            ref={input => {
              this.password = input;
            }}
            placeholder={UIText.loginFieldPassword}
            leftIcon={<Icon name="repeat" size={24} color="black" />}
            returnKeyType="go"
            blurOnSubmit={true}
            value={this.controller.fieldData.password}
            editable={!this.controller.signingIn}
            secureTextEntry={true}
            onChange={e => {
              this.controller.updateFields("password", e);
            }}
            onEndEditing={e => {
              this.controller.updateFields("password", e);
            }}
            onBlur={e => {
              this.password.props.onEndEditing(e);
            }}
            onSubmitEditing={this.controller.execSignIn}
          />
        </View>

        <ThemedButton
          ref={ref => (this.button = ref)}
          style={this.props.styles.button}
          disabled={this.controller.buttonDisabled || this.controller.signingIn}
          title={UIText.login}
          loading={this.controller.signingIn}
          onPress={this.controller.execSignIn}
        />

        <View style={this.props.styles.links}>
          {embeddedService.isEmbedded && (
            <Text
              style={this.props.styles.link}
              onPress={e => {
                this.controller.handleLinkPress("visitor", e);
              }}
            >
              {UIText.loginShowGenericMarket}
            </Text>
          )}
          {/*<Text*/}
          {/*  style={this.props.styles.link}*/}
          {/*  onPress={e => {*/}
          {/*    this.controller.handleLinkPress("register", e);*/}
          {/*  }}*/}
          {/*>*/}
          {/*  {UIText.loginLinkRegister}*/}
          {/*</Text>*/}
          <Text
            style={this.props.styles.link}
            onPress={e => {
              this.controller.handleLinkPress("reset", e);
            }}
          >
            {UIText.loginLinkReset}
          </Text>
        </View>
      </View>
    );
  }
}

export { LoginScreen };
